import axios from 'axios';
import { API_BASE_URL } from '../constants/api';
import { Announcement } from '../types/Announcement';
import { rememberAnnouncementRead, rememberAnnouncementsRead } from '../utils/announcement';

// Paylaşılan api istemcisi null ve [] gövdelerini oturum kapanması sayıyor.
// Duyuru uçları kayıt yokken ve okundu işaretinden sonra null, liste boşken [] döner.
const announcementApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  // Gövdeyi kendimiz ayıralım: boş metin oturum kapalı, JSON null kayıt yok.
  transformResponse: [(data) => data],
});

announcementApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

function expireSession(): never {
  localStorage.removeItem('auth_token');
  window.location.href = '/login';
  throw new Error('Oturum süresi doldu');
}

function parseBody(data: unknown): unknown {
  if (typeof data !== 'string' || data.trim() === '') {
    expireSession();
  }

  try {
    return JSON.parse(data);
  } catch {
    throw new Error('Duyuru yanıtı okunamadı');
  }
}

function asAnnouncement(value: unknown): Announcement | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  if (!('Baslik' in value)) return null;
  return value as Announcement;
}

export async function getAnnouncements(): Promise<Announcement[]> {
  const response = await announcementApi.get('/user/notifications/get=all');
  const data = parseBody(response.data);
  if (!Array.isArray(data)) return [];

  return data
    .map(asAnnouncement)
    .filter((item): item is Announcement => item !== null && typeof item.Id === 'number');
}

export async function getPriorityAnnouncement(): Promise<Announcement | null> {
  const response = await announcementApi.get('/user/notifications');
  const announcement = asAnnouncement(parseBody(response.data));
  if (!announcement || typeof announcement.Id !== 'number') return null;
  return announcement;
}

export async function markAnnouncementRead(id: number): Promise<void> {
  const formData = new URLSearchParams();
  formData.append('id', String(id));
  formData.append('type', 'set');

  const response = await announcementApi.post('/user/notifications', formData);
  parseBody(response.data);
  rememberAnnouncementRead(id);
}

export async function markAllAnnouncementsRead(ids: number[]): Promise<void> {
  const formData = new URLSearchParams();
  formData.append('type', 'setall');

  const response = await announcementApi.post('/user/notifications', formData);
  parseBody(response.data);
  rememberAnnouncementsRead(ids);
}
